import type { TreeData } from '../../Editor/_hooks/useSyncScroll'

export const syncScrollPlugin = (
  treeDataRef?: React.RefObject<TreeData | null>,
  onTreeReady?: () => void
) => {
  return () => {
    return (tree: TreeData) => {
      if (treeDataRef?.current !== undefined) {
        treeDataRef.current = tree
        onTreeReady?.()
      }
    }
  }
}
